<template>
	
		<div class="mdc-card mgt-24 pdt-24 pdb-16 pdl-24 pdr-24" v-if="listData && shortAnswer">
			<div class="t-color4 t-color-bodyGrayA l-spacing36 font-r t-body3">{{ $t('1958')}}</div>
					<div class="mgt-8 mgb-16 font-m t-subtitle3">
						<vue-mathjax :formula="listData.question.contents" v-if="listData.question.useMathjax"></vue-mathjax>
						<div v-else>
							{{ listData.question.contents }}
						</div>
					</div>
					<div v-if="questionImage">
						<img class="round mgb-8" :src="questionImage" alt="" />
				</div>
				<div class="question-choices">
					<div class="t-body2 mgt-16">
						<!-- {{isCorrect() ? $t('1270') : $t('1271')}} -->
						<!-- Your answer is correct -->
					</div>
					<!-- <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-4" :id="`answerEl`">
						<input type="text" class="mdc-text-field__input"
							maxlength="50"
							autocomplete="off"
							v-model="textAnswer"
							readonly
						>
						<div class="mdc-notched-outline">
							<div class="mdc-notched-outline__leading"></div>
							<div class="mdc-notched-outline__notch">
							
							</div>
							<div class="mdc-notched-outline__trailing"></div>
						</div>
					</div> -->
								<label
				class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 mdc-text-field--disabled disabled--Updated"
				data-mdc-auto-init="MDCTextField"
				:id="`answerEl`"
					>
				<span class="mdc-notched-outline">
					<span class="mdc-notched-outline__leading"></span>
					<span class="mdc-notched-outline__notch">
						<!-- <span class="mdc-floating-label" id="my-label-id">{{$t('1256')}}</span> -->
					</span>
					<span class="mdc-notched-outline__trailing"></span>
				</span>
				<input class="mdc-text-field__input" type="text" aria-labelledby="my-label-id"
							maxlength="50"
							autocomplete="off"
							v-model="textAnswer"
							readonly
							disabled
				/>
			</label>
					<div v-if="!shortAnswer.correct" class="mgt-16">
						<hr class="divider">
						<div class="t-body2 mgt-16" style="color: var(--HeadlineBlack) !important;">
							{{$t('1272')}}
							<!-- Check the right answer! -->
						</div>
						<div class="t-body2 bg-quizGray b-radius4 pdr-24 mgb-8" style="color: var(--HeadlineBlack) !important;">
							<div class="t-body1 choice">
								<div class="mgr-16 mgl-16">
									<span>{{textCorrect}}</span>
								</div>
							</div>
						</div>
					</div>
					
				</div>
			</div>
</template>

<script>
/**
 * 단일답안 문항 피드백 컴포넌트(short answer type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */
import {MDCTextField} from '@material/textfield'
import {questionMixin} from '@/mixins/question.js'
export default {
	props: ['listData', 'shortAnswer'],
	data() {
		return {
			textAnswer: '',
			textCorrect: '',
			questionImage:null
		}
	},
	mixins: [questionMixin],
	mounted() {
		this.textAnswer = this.shortAnswer.textAnswer
		this.textCorrect = this.shortAnswer.textCorrect
		if(this.listData && this.listData.question && this.listData.question.image) {
			let getImage = this.listData.question.image.resourceUri.split('default_thumnail_en.jpg')
			if(getImage[1] !=''){
				this.questionImage = this.listData.question.image.resourceUri;
			} else {
				this.questionImage = null
			}
		}

		const textField = new MDCTextField(document.getElementById(`answerEl`))
	},
	components: {
	
	},

}
</script>
